<template>
  <div class="custom-actions">
    <button class="btn btn-sm btn-primary" title="Editar"
            @click="editar(rowData)"><i class="fa fa-pencil"></i></button>
  </div>
</template>
<script>
export default {
  name: "custom-actions",
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    editar(data) {
      this.$router.push({ path: `/denuncia/replica-denuncia/${data.protocolo}` });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/CustomActions.vue